import { FeatureQuickBar } from '../components/inventory/feature-quick-bar.vue';
Vue.component('feature-quick-bar', FeatureQuickBar);
